// extracted by css-extract-rspack-plugin
export default {"buildCard":"cW5IgW4GndMjE7bb","successfulBuild":"wNrtXbp9Rc4CNbIv","failedBuild":"XAPiz0NjW0kUe6UB","buildTimeSection":"tTAYuHbJTjMlQ5Rs"};